import React from "react";
import { Badge } from "../components/ui/badge";
import { fmtQual } from "../lib/api";

const MAP = {
  autonomia: {
    verde: ["Autosufficiente", "#dcfce7", "#15803d"],
    arancione: ["Parz. autosufficiente", "#ffedd5", "#c2660c"],
    rosso: ["Segnalato ADI", "#fee2e2", "#dc2626"],
  },
  presenza: {
    presente: ["Presente", "#dcfce7", "#15803d"],
    ospedale: ["Ricoverato", "#fee2e2", "#dc2626"],
    uscita: ["Uscito", "#fef9c3", "#a16207"],
    dimesso: ["Dimesso", "#e5e7eb", "#4b5563"],
  },
  priorita: {
    normale: ["Normale", "#e5e7eb", "#4b5563"],
    importante: ["Importante", "#fef9c3", "#a16207"],
    urgente: ["Urgente", "#fee2e2", "#dc2626"],
  },
  stato: {
    attivo: ["Attivo", "#dcfce7", "#15803d"], attiva: ["Attiva", "#dcfce7", "#15803d"],
    pagato: ["Pagato", "#dcfce7", "#15803d"], pagata: ["Pagata", "#dcfce7", "#15803d"],
    parziale: ["Parziale", "#fef9c3", "#a16207"],
    "non pagato": ["Non pagato", "#fee2e2", "#dc2626"], "non pagata": ["Non pagata", "#fee2e2", "#dc2626"],
    ricoverato: ["Ricoverato", "#fee2e2", "#dc2626"],
    programmato: ["Programmato", "#dbeafe", "#2563eb"], confermato: ["Confermato", "#dcfce7", "#15803d"],
    completato: ["Completato", "#dcfce7", "#15803d"], completata: ["Completata", "#dcfce7", "#15803d"],
    "in corso": ["In corso", "#fef9c3", "#a16207"], in_corso: ["In corso", "#fef9c3", "#a16207"],
    da_fare: ["Da fare", "#dbeafe", "#2563eb"], non_completata: ["Non completata", "#fee2e2", "#dc2626"],
    rientrato: ["Rientrato", "#dcfce7", "#15803d"], annullato: ["Annullato", "#e5e7eb", "#4b5563"],
    assente: ["Assente", "#fef9c3", "#a16207"], sospeso: ["Sospeso", "#fee2e2", "#dc2626"],
    cessato: ["Cessato", "#e5e7eb", "#4b5563"], sospesa: ["Sospesa", "#fef9c3", "#a16207"],
    conclusa: ["Conclusa", "#e5e7eb", "#4b5563"], rinviata: ["Rinviata", "#fef9c3", "#a16207"],
  },
  tipo: { ordinaria: ["Ordinaria", "#dbeafe", "#2563eb"], bisogno: ["Al bisogno", "#fef3c7", "#b45309"] },
  qualifica: {},
};

export default function StatusBadge({ type, value }) {
  if (!value) return <span>—</span>;
  if (type === "qualifica") return <Badge variant="secondary" data-testid={`badge-${value}`}>{fmtQual(value)}</Badge>;
  const conf = (MAP[type] || {})[value];
  if (!conf) return <Badge variant="secondary" data-testid={`badge-${value}`}>{value}</Badge>;
  const [label, bg, fg] = conf;
  return (
    <span data-testid={`badge-${value}`} style={{ background: bg, color: fg }}
      className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-bold">{label}</span>
  );
}
